import {
	AfterViewInit,
	Component,
	ElementRef,
	NgZone,
	OnChanges,
	OnDestroy,
	SimpleChanges,
	ViewChild,
	ViewEncapsulation,
} from '@angular/core';
import { createRoot, Root } from 'react-dom/client';
import { ReceptionHome } from 'src/routes/reception_home/mod';
import { WebContentButtonsService } from '../app/Services/api/v2/Units/webContentButtons.service';
import { StartupService } from '../app/Services/app/startup.service';
import { CellulaProviderWrapper } from './cellula_provider_wrapper.component';

const containerElementName = 'reactReceptionHomeComponent';

@Component({
	standalone: false,
	styleUrls: ['./css/reception-home.wrapper.scss'],
	selector: 'reception-home-component',
	template: `
		<semantic-view>
			<header-component header></header-component>
			<div class="wrapper-container" #${containerElementName}></div>
			<footer-component footer></footer-component>
		</semantic-view>
	`,
	encapsulation: ViewEncapsulation.None,
})
export class ReceptionHomeWrapperComponent implements OnChanges, OnDestroy, AfterViewInit {
	@ViewChild(containerElementName, { static: false }) containerRef: ElementRef;

	private root: Root;
	public extraHeaderHeight: boolean = false;

	constructor(
		private readonly ngZone: NgZone,
		private readonly webContentButtonsService: WebContentButtonsService,
	) {}

	ngOnChanges(_: SimpleChanges): void {
		// noop
	}

	ngAfterViewInit(): void {
		this.render();
	}

	ngOnDestroy(): void {
		this.root?.unmount();
	}

	private requestSignIn(flexibleIdentifierData: { url: string; openUrlWith: string; requiresAuthentication: boolean }): void {
		// biome-ignore lint/suspicious/noExplicitAny: suppressed due to migration - should be fixed
		this.webContentButtonsService.goToCustomButtonUrl(flexibleIdentifierData as any);
	}

	private render(): void {
		const root = createRoot(this.containerRef.nativeElement);
		this.root = root;

		const forwardSignIn = (flexibleIdentifierData: { url: string; openUrlWith: string; requiresAuthentication: boolean }): void => {
			this.ngZone.run(() => {
				this.requestSignIn(flexibleIdentifierData);
			});
		};

		this.ngZone.runOutsideAngular(() => {
			root.render(
				<CellulaProviderWrapper useGlobals>
					<ReceptionHome __TEMP__on_OPW_WebContentButton_proxy_invoke={forwardSignIn} />
				</CellulaProviderWrapper>,
			);
		});
	}
}
